import React, { useState, useEffect, lazy, Suspense } from "react";
import { Headers } from "../../layouts/headers/headers";
import { MainContent } from "../../layouts/MainContent";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { PublicityList } from "../../components/datatable/PublicityList";
import { getPublicityAll } from "../../interpreter/publicity";
import PublicityFilter from "../../components/filters/filterPublicity";
import { FaPlus } from "react-icons/fa"; // Ícono más liviano

// ✅ Lazy loading de modales
const UserModal = lazy(() => import("../../components/modals/profileUser"));
const AggPublicity = lazy(() => import("../../components/modals/aggPublicity"));
const UpdatedPublicity = lazy(() => import("../../components/modals/updatePublicity"));

const Publicity = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const [selectedPublicity, setSelectedPublicity] = useState(null);
  const [publicitys, setPublicitys] = useState([]);

  // Cargar publicidades
  const fetchPublicity = async () => {
    try {
      const data = await getPublicityAll();
      if (Array.isArray(data)) {
        setPublicitys(data);
      } else {
        console.warn("No hay publicidades disponibles.");
        setPublicitys([]);
      }
    } catch (error) {
      console.error("Error al obtener publicidades:", error);
      setPublicitys([]);
    }
  };

  useEffect(() => {
    fetchPublicity();
  }, []);

  const openModal = (modalType, publicity) => {
    setSelectedPublicity(publicity);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
    setSelectedPublicity(null);
  };

  const handleAddPublicity = (newPublicity) => {
    setPublicitys(prev => [...prev, { id: prev.length + 1, ...newPublicity }]);
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Headers />

      {/* Contenido principal */}
      <MainContent>
        <HeadersCentral
          showDropdown={showDropdown}
          setShowDropdown={setShowDropdown}
          openModal={() => openModal('user')}
        />

        <main className="p-6 w-full">
          <h1 className="text-2xl font-bold mb-7">Panel de Control de Publicidad</h1>
          <PublicityFilter setPublicity={setPublicitys} />

          {/* Botón de agregar publicidad */}
          <div className="mb-4">
            <button
              className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md flex items-center gap-2 w-auto"
              onClick={() => openModal('add')}
            >
              <FaPlus size={16} /> Agregar Publicidad
            </button>
          </div>

          {/* Tabla de publicidades */}
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-auto w-full">
            <PublicityList
              openModal={openModal}
              publicitys={publicitys}
              setPublicitys={setPublicitys}
            />
          </div>
        </main>
      </MainContent>
      {/* Modales */}
      <Suspense fallback={null}>
        {activeModal === 'user' && <UserModal isOpen={true} onClose={closeModal} />}
        {activeModal === 'add' && (
          <AggPublicity
            isOpen={true}
            onClose={closeModal}
            addPublicity={handleAddPublicity}
            onSuccess={fetchPublicity}
          />
        )}
        {activeModal === 'reset' && (
          <UpdatedPublicity
            isOpen={true}
            onClose={closeModal}
            publicity={selectedPublicity}
            onSuccess={fetchPublicity}
          />
        )}
      </Suspense>
    </div>
  );
};

export default Publicity;
